import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';
import { confirmUnsavedChanges } from '../../hooks/useDraftRecovery';

export default function UnsavedNavigationGuard() {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  useEffect(() => {
    const push = navigator.push;
    const replace = navigator.replace;
    let index = window.history.state?.idx ?? 0;
    let restoring = false;
    const allowed = (to: Parameters<typeof push>[0]) => {
      const target = typeof to === 'string' ? to : `${to.pathname || window.location.pathname}${to.search || ''}`;
      return target === `${window.location.pathname}${window.location.search}` || !localStorage.getItem('token') || confirmUnsavedChanges();
    };
    navigator.push = (...args) => { if (allowed(args[0])) { push(...args); index = window.history.state?.idx ?? index; } };
    navigator.replace = (...args) => { if (allowed(args[0])) { replace(...args); index = window.history.state?.idx ?? index; } };
    const onPop = (event: PopStateEvent) => {
      const next = event.state?.idx;
      if (restoring) { restoring = false; index = next ?? index; return; }
      if (typeof next === 'number' && next !== index && localStorage.getItem('token') && !confirmUnsavedChanges()) {
        event.stopImmediatePropagation();
        restoring = true;
        window.history.go(index - next);
      } else index = next ?? index;
    };
    window.addEventListener('popstate', onPop, true);
    return () => { navigator.push = push; navigator.replace = replace; window.removeEventListener('popstate', onPop, true); };
  }, [navigator]);
  return null;
}
